import api from './api';

export const getCountriesApi = () => api().get('/countries');
